import BasePolicy from '@/policies/BasePolicy.js';

export default class QuizAttemptPolicy extends BasePolicy {
    /**
     *
     * @param {User} user
     * @param {Course} course
     * @returns {*}
     */
    viewOther(user, course) {
        return user.hasPermissionViaCourseTo(course, "view another user's quiz attempt");
    }

    /**
     *
     * @param user
     * @param course
     * @returns {*}
     */
    createOther(user, course) {
        const groupPermission = user.hasGroupPermissionWithinCourse(course, "create another user's quiz attempt");

        return user.hasPermissionViaCourseTo(course, "create another user's quiz attempt") || groupPermission;
    }

    /**
     *
     * @param user
     * @returns {*}
     */
    viewAny(user) {
        return user.hasPermissionTo('view a quiz attempt');
    }

    /**
     *
     * @param {User} user
     * @param {Course} course
     * @returns {*}
     */
    viewAnyWithinCourse(user, course) {
        return user.hasPermissionViaCourseTo(course, 'view a quiz attempt');
    }

    /**
     *
     * @param user
     * @param quizAttempt
     * @returns {false|*}
     */
    view(user, quizAttempt) {
        return user.id === quizAttempt.user_id && user.hasPermissionTo('view a quiz attempt');
    }

    /**
     *
     * @param {User} user
     * @param {Course} course
     * @returns {*}
     */
    create(user, course) {
        return user.hasPermissionViaCourseTo(course, 'create a quiz attempt');
    }

    /**
     *
     * @param {User} user
     * @param {Course} course
     * @returns {*}
     */
    delete(user, course) {
        return user.hasPermissionViaCourseTo(course, 'delete a quiz attempt');
    }

    /**
     * @param {User} user
     * @returns {*}
     */
    addTime(user) {
        return user.hasPermissionTo('add time to a quiz attempt');
    }

    canEndQuizzes(user, course) {
        return user.hasPermissionTo('can end quizzes');
    }
}
